<!-- https://8es9hr.axshare.com/#g=1&p=%E7%A4%BE%E5%93%A1%E8%BD%89%E5%B8%B3%E5%82%99%E5%BF%98%E9%8C%84 -->
<!-- 社員存摺列印 -->
<template>
	<div class="row" v-if="$route.meta.subListKeepAlive">
		<div class="col-12">
			<div class="mb10">
				<el-button type="primary" plain @click="go('cabinet_edit')"
					>回社員首頁</el-button
				>
				<el-button type="danger" plain @click="go('cabinet_search')"
					>搜尋其他社員</el-button
				>
			</div>
			<div class="col-block">
				<div class="block-header has-border">
					<h3>
						<strong v-if="dataArr !== ''"
							>{{ dataArr.account }} {{ dataArr.idNumber }}
							{{ dataArr.name }}</strong
						>
					</h3>
					<br />
					<!-- 只有社員可以搜尋其他社員 -->
					<h3>
						<strong>備轉金 存摺列印</strong>
					</h3>
				</div>
				<ListForm
					:id="id"
					labelPosition="top"
					:recordToEdit="recordToEdit"
					:formType="formType"
				>
					<div slot="footer" class="dialog-footer"></div>
				</ListForm>

				<div class="block-content">
					<!-- list -->
					<!-- 缺少 開立轉帳傳票 filter 傳票開立狀態 -->
					<el-table
						ref="table"
						:data="list"
						max-height="800"
						@select="handleSelect"
						@select-all="handleSelectAll"
					>
						<el-table-column
							type="index"
							align="center"
							width="50"
							fixed
						></el-table-column>
						<el-table-column
							type="selection"
							fixed
						></el-table-column>
						<el-table-column align="center" width="70">
							<!-- <template slot-scope="scope">
                                <el-button type="success"
                                           icon="el-icon-edit"
                                           size="mini"
                                           @click="editData(scope.row.id,scope.row)"></el-button>
                            </template>-->
						</el-table-column>
						<el-table-column
							v-for="col of columns"
							v-bind="col"
							v-loading="loading"
							:show-overflow-tooltip="true"
							:highlight-current-row="true"
							:key="col.label"
							:prop="col.prop"
							sortable="custom"
						>
							<template slot-scope="scope">
								<custom-row
									:scope="scope"
									:renderFunction="col.renderFunction"
									:enumData="enumData"
									v-if="col.renderFunction"
								></custom-row>
								<div v-else-if="col.addcomma">
									{{ $addcomma(scope.row[col.prop]) }}
								</div>
								<div v-else>{{ scope.row[col.prop] }}</div>
							</template>
						</el-table-column>
					</el-table>
					<el-button type="primary" plain @click="print" class="mt10"
						>列印</el-button
					>
				</div>
			</div>
		</div>
	</div>
	<router-view v-else></router-view>
</template>
<script>
import Workbench from "@/components/Workbench";
import { API } from "@/assets/config";
import ListForm from "@/components/ListForm.vue";
export default {
	name: "cabinet_transfer_passbook",
	components: { Workbench, ListForm },
	data() {
		return {
			id: this.$route.params.id,
			api: "",
			loading: false,
			originData: [],
			originData2: [],
			multipleSelection: [],
			transferIdList: [],
			repaymnetDateList: [],
			withdrawalDateList: [],
			dataArr: {},
			query: {
				action: "getUpdatePassbook",
			},
			searchDate: [],
			currentEdit: {},
			dialogAddItem: false,
			// 銀行帳戶
			accounts: [],
			recordToEdit: {},
			toolbar: {
				allClose: true,
				search: false,
			},
			filter: {},
			columns: [
				{
					prop: "voucherDate",
					label: "日期",
				},
				{
					label: "傳票號",
					prop: "voucherCode",
				},
				{
					label: "摘要",
					prop: "note",
				},
				{
					label: "存入",
					prop: "saveAmount",
					addcomma: true,
				},
				{
					label: "退款",
					prop: "withdrawalAmount",
					addcomma: true,
				},
				{
					label: "結餘",
					prop: "amount",
					addcomma: true,
				},
			],
			formType: [
				{
					label: "列印種類",
					key: "type",
					type: "radio",
					options: [
						{
							label: "封面",
							value: 0,
						},
						{
							label: "補摺",
							value: 1,
						},
						{
							label: "自訂列印",
							value: 2,
						},
					],
				},
				{
					label: "列印位置",
				},
				{
					label: "頁",
					key: "printPage",
					type: "input",
				},
				{
					label: "列",
					key: "printRow",
					type: "input",
				},
			],
		};
	},
	computed: {
		list() {
			return this.originData.map((item) => {
				const newItem = {
					...item,
				};
				Object.keys(newItem).map(function (key, index) {
					// 正則日期格式轉為民國年
					// 2019-12-31 12:00:00
					var regDateTime = /^(\d{4})\-(\d{2})\-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/;
					// 2019-12-31
					var regDate = /^(\d{4})\-(\d{2})\-(\d{2})$/;
					var regExpDateTime = new RegExp(regDateTime);
					var regExpDate = new RegExp(regDate);

					if (
						regExpDate.test(newItem[key]) ||
						regExpDateTime.test(newItem[key])
					) {
						newItem[key] = newItem[key] = `${
							newItem[key].substring(0, 4) - 1911
						}-${newItem[key].substring(5, 10)}`;
					}
				});
				return newItem;
			});
		},
	},
	watch: {
		"recordToEdit.type": {
			handler(NewVal) {
				if (NewVal == 1) {
					this.multipleSelection = [];
					let action = "getTransferUpdatePassbook";
					this.getList(action);
				} else if (NewVal == 2) {
					this.multipleSelection = [];
					let action = "getTransferAllPassbook";
					this.getList(action);
				}
			},
		},
	},
	created() {
		this.getData();
		this.getRowData();
	},
	methods: {
		getData() {
			const url = API.counterWork + `?id=${this.id}&action=getMemberData`;
			const thenCB = (json) => {
				// this.recordToEdit = json.resultData;
				this.dataArr = json.resultData.memberInfo.member;
				// json.resultData.filter(items => {
				//     if (items.member.id == this.id) {
				//         this.dataArr = items;
				//     }
				// });
			};

			this.mAxiosGet(url, thenCB);
		},
		getRowData() {
			const url =
				API.counterWork +
				`?action=getTransferPrintPageRow&memberId=${this.id}`;
			const thenCB = (json) => {
				this.recordToEdit = json.resultData.data;
			};

			this.mAxiosGet(url, thenCB);
		},
		getList(action) {
			let url = API.counterWork + `?action=${action}&memberId=${this.id}`;
			const loading = this.$loading({
				lock: true,
				text: "Loading",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.7)",
			});
			this.$http.get(url).then((res) => {
				this.originData = res.data.resultData.data.transferStockRecord;
				loading.close();
			});
		},
		go(name) {
			this.$router.push({ name: name });
		},
		editData(id, row) {
			// edit
			this.dialogAddItem = true;
			this.currentEdit = {};
			if (id !== "new") {
				this.currentEdit = row;
			}
		},
		transferData(row) {
			// 交易明細有臨櫃作業與社員搜尋兩組子路由，本頁路徑一定帶 :id，
			// 走社員版才能在返回時回到該社員（詳見 router.js cabinet_transfer）
			const memberId = this.$route.params.id;

			this.$router.push(
				memberId == null
					? {
						name: "cabinet_transfer_detail",
						params: { subId: row.id, dataArr: this.dataArr },
					}
					: {
						name: "cabinet_member_transfer_detail",
						params: { id: memberId, subId: row.id, dataArr: this.dataArr },
					}
			);
		},
		saveData() {
			var url = API.memberTransferMemo;
			const form = new FormData();
			const object = this.currentEdit;

			if (this.currentEdit.id) {
				url += `?action=update`;
			} else {
				url += `?action=append`;
			}

			Object.keys(object).map(function (objectKey, index) {
				var value = object[objectKey];
				form.append(objectKey, value !== undefined ? value : "");
			});

			let thenCB = (json) => {
				this.showAjaxSuccessMsg();
			};
			this.mAxiosPost(url, form, thenCB);
		},
		handleSelect(val) {
			if (this.multipleSelection.length > 0) {
				this.$refs.table.clearSelection();
				this.multipleSelection = [];
			} else {
				this.getFirstPostion(val);
			}
		},
		handleSelectAll(selection) {
			let transferIdList = [];
			let repaymnetDateList = [];
			let withdrawalDateList = [];
			this.multipleSelection = selection;
			// this.originData2.forEach(item => {
			//     if (item.id !== undefined) {
			//         transferIdList.push(item.id);
			//     }
			//     if (item.voucherDate != undefined) {
			//         repaymnetDateList.push(item.voucherDate);
			//     }
			// });
			this.originData.forEach((item) => {
				if (item.date !== undefined) {
					withdrawalDateList.push(item.date);
				}
			});
			selection.forEach(item => transferIdList.push(item.id));
			this.transferIdList = transferIdList;
			this.repaymnetDateList = repaymnetDateList;
			this.withdrawalDateList = withdrawalDateList;
		},
		getFirstPostion(rows) {
			if (rows) {
				let keys = "";
				rows.findIndex((row) => {
					this.list.forEach((key) => {
						if (row.virtualId == key.virtualId) {
							return (keys = row.virtualId);
						}
					});
				});
				this.findKey(keys);
			}
		},
		findKey(keys) {
			let index = this.list.findIndex((key) => {
				if (keys == key.virtualId) {
					return true;
				}
			});
			this.$refs.table.toggleRowSelection(this.list[index]);
			this.toggleSelection(index);
		},
		toggleSelection(index, row) {
			let arr = [];
			let transferIdList = [];
			// let repaymnetDateList = [];
			let withdrawalDateList = [];
			let length = this.list.length;
			for (var i = index; i < length; i++) {
				this.$refs.table.toggleRowSelection(this.list[i]);
			}
			this.originData.forEach((item, idx) => {
				if (idx >= index) {
					arr.push(item);
					if (item.voucherDate !== undefined) {
						withdrawalDateList.push(item.voucherDate);
					}
					if (item.id !== undefined) {
						transferIdList.push(item.id);
					}
				}
			});
			this.transferIdList = transferIdList;
			// this.repaymnetDateList = repaymnetDateList;
			this.withdrawalDateList = withdrawalDateList;
			this.multipleSelection = arr;
		},
		print() {
			let url = API.counterWork;
			if (
				this.multipleSelection.length == 0 &&
				this.recordToEdit.type !== 0
			) {
				this.$message.closeAll();
				this.$message({
					type: "warning",
					message: "請選擇資料",
				});
			} else if (this.recordToEdit.type == 0) {
				const form = new FormData();
				url += "?action=printPassbookTitle";
				form.append("memberId", this.id);
				let thenCB = (json) => {
					this.base64 = [
						{
							data: json.resultData,
						},
					];
					setTimeout(() => {
						this.printReport();
					}, 0);
				};
				this.mAxiosPost(url, form, thenCB);
			} else {
				const form = new FormData();
				if (this.recordToEdit.type == 1) {
					url += "?action=printTransferUpdatePassbook";
				} else if (this.recordToEdit.type == 2) {
					url += "?action=printTransferAllPassbook";
				}

				form.append("memberId", this.id);
				form.append(
					"transferIdList",
					JSON.stringify(this.transferIdList)
				);
				// form.append(
				//     "repaymnetDateList",
				//     JSON.stringify(this.repaymnetDateList)
				// );
				// form.append(
				//     "withdrawalDateList",
				//     JSON.stringify(this.withdrawalDateList)
				// );
				form.append("printPage", this.recordToEdit.printPage || "");
				form.append("printRow", this.recordToEdit.printRow || "");
				let thenCB = (json) => {
					this.base64 = json.resultData;
					setTimeout(() => {
						this.printReport();
					}, 0);
				};
				this.mAxiosPost(url, form, thenCB);
			}
		},
		printReport() {
			const url = "http://localhost:4330/transfer/print";
			const form = new FormData();
			const vm = this;
			let data = this.base64;
			let length = data.length;
			if (length == 1) {
				form.append("test", JSON.stringify(this.base64[0].data));
				let thenCB = (result) => {
					if (result == "") {
						this.$message({
							type: "success",
							message: "成功",
						});
					} else {
						this.$message({
							type: "error",
							message: result.errorMessage,
						});
					}
				};
				fetch(url, { method: "post", body: form })
					.then((data) => (data.status != 200 ? data.json() : ""))
					.then((result) => thenCB(result));

				this.base64.splice(0, 1);
			} else if (length > 1) {
				form.append("test", JSON.stringify(this.base64[0].data));
				this.$alert("繼續列印", "提示", {
					dangerouslyUseHTMLString: true,
					confirmButtonText: "繼續列印",
					type: "warning",
					showClose: false,
				}).then(() => {
					this.continuePrint();
				});
				let thenCB = (result) => {
					if (result == "") {
						this.$message({
							type: "success",
							message: "成功",
						});
					} else {
						this.$message({
							type: "error",
							message: result.errorMessage,
						});
					}
				};
				fetch(url, { method: "post", body: form })
					.then((data) => (data.status != 200 ? data.json() : ""))
					.then((result) => thenCB(result));
				this.base64.splice(0, 1);
			}
		},
		continuePrint() {
			//判斷目前的長度有資料再去post
			let data = this.base64;
			if (data.length > 0) {
				this.printReport();
			}
		},
		getEnumData(data) {
			this.accounts = data.bank;
		},
		search() {
			this.filter = {
				searchDate: [this.searchDate[0], this.searchDate[1]],
			};
		},
	},
};
</script>
<style lang="scss" scoped>
.block-content {
	.box-card {
		margin-bottom: 10px;

		&:last-child {
			margin-bottom: 0;
		}

		.table {
			td {
				vertical-align: middle;
			}
		}
	}
}
</style>